import { render, staticRenderFns } from "./Room4.vue?vue&type=template&id=18185739&scoped=true&"
import script from "./Room4.vue?vue&type=script&lang=ts&"
export * from "./Room4.vue?vue&type=script&lang=ts&"
import style0 from "./Room4.vue?vue&type=style&index=0&id=18185739&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18185739",
  null
  
)

export default component.exports